import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../axiosConfig';
import imgPrefix from '../imgConfig';
import '../styles/FooterNav.css';

const FooterNav = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState({
    logo: '',
    address: '',
    phone: '',
    branches: [],
    socials: [],
    services: [],
    extra: '',
    backgroundColor: '',
  });

  useEffect(() => {
    const loadConfig = async () => {
      setLoading(true);
      try {
        // logo
        const logoRes = await axios.get('/config/list', {
          params: { page: 1, limit: 1, sort: 'id', name: 'homepage_logo' },
        });
        let logo = '';
        if (
          logoRes.data &&
          logoRes.data.code === 0 &&
          logoRes.data.data.list &&
          logoRes.data.data.list.length > 0
        ) {
          const row = logoRes.data.data.list[0];
          if (row.value) {
            // 与 admin 端保持一致，value 可能是逗号分隔的多图
            logo = row.value.split(',')[0];
          }
        }

        // footer config
        const footerRes = await axios.get('/config/list', {
          params: { page: 1, limit: 1, sort: 'id', name: 'homepage_footer_config' },
        });
        let footer = {
          address: '',
          phone: '',
          branches: [],
          socials: [],
          services: [],
          extra: '',
          backgroundColor: '',
        };
        if (
          footerRes.data &&
          footerRes.data.code === 0 &&
          footerRes.data.data.list &&
          footerRes.data.data.list.length > 0
        ) {
          const row = footerRes.data.data.list[0];
          if (row.value) {
            try {
              const obj = JSON.parse(row.value);
              footer = {
                address: obj.address || '',
                phone: obj.phone || '',
                branches: obj.branches || [],
                socials: obj.socials || [],
                services: obj.services || [],
                extra: obj.extra || '',
                backgroundColor: obj.backgroundColor || '',
              };
            } catch (e) {
              console.error('Failed to parse homepage_footer_config', e);
            }
          }
        }

        setConfig({
          logo,
          ...footer,
        });
      } catch (e) {
        console.error('Failed to load homepage footer config', e);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  if (loading) {
    return null;
  }

  const hasBaseInfo = config.address || config.phone;
  const hasBranches = config.branches && config.branches.length > 0;
  const hasSocials = config.socials && config.socials.length > 0;
  const hasServices = config.services && config.services.length > 0;

  if (!config.logo && !hasBaseInfo && !hasBranches && !hasSocials && !hasServices && !config.extra) {
    return null;
  }

  return (
    <div className="footer-nav" 
      style={config.backgroundColor ? { backgroundColor: config.backgroundColor } : undefined}
    >
      <div className="footer-nav-main">
        <div className="footer-nav-logo-block">
          {config.logo && (
            <img
              src={`${imgPrefix}/${config.logo}`}
              alt="logo"
              className="footer-nav-logo"
            />
          )}
        </div>

        <div className="footer-nav-info">
          {hasBaseInfo && (
            <div className="footer-nav-section">
              <h4>{t('footerNav.contactTitle')}</h4>
              {config.address && (
                <div className="footer-nav-line">
                  {t('footerNav.addressLabel')}: {config.address}
                </div>
              )}
              {config.phone && (
                <div className="footer-nav-line">
                  {t('footerNav.phoneLabel')}: {config.phone}
                </div>
              )}
            </div>
          )}

          {hasBranches && (
            <div className="footer-nav-section">
              <h4>{t('footerNav.branchTitle')}</h4>
              {config.branches.map((b, idx) => (
                <div key={idx} className="footer-nav-line">
                  <span className="footer-nav-branch-name">{b.name}</span>
                  {b.address && <span className="footer-nav-branch-address"> - {b.address}</span>}
                  {b.phone && <span className="footer-nav-branch-phone"> ({b.phone})</span>}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="footer-nav-right">
          {hasSocials && (
            <div className="footer-nav-section">
              <h4>{t('footerNav.socialTitle')}</h4>
              {config.socials.map((s, idx) => (
                <div key={idx} className="footer-nav-line">
                  <span>{t('footerNav.platformLabel', { platform: s.platform })}</span>
                  {s.url && (
                    <a
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-nav-link"
                    >
                      {s.url}
                    </a>
                  )}
                </div>
              ))}
            </div>
          )}

          {hasServices && (
            <div className="footer-nav-section">
              <h4>{t('footerNav.servicesTitle')}</h4>
              <div className="footer-nav-tags">
                {config.services.map((s, idx) => (
                  <span key={idx} className="footer-nav-tag">
                    {s.name}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {config.extra && (
        <div className="footer-nav-extra">
          {config.extra}
        </div>
      )}
    </div>
  );
};

export default FooterNav;



